import { OnInit, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { LaboratoryAppointmentQuestion } from "src/app/model/laboratory-appointment-question/laboratory-appointment-question";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";

@Component({
  selector: "app-laboratory-appointment-question-dialog",
  templateUrl: "laboratory-appointment-question-dialog.component.html",
  styleUrls: ["./laboratory-appointment-question-dialog.component.css"],
})
export class LaboratoryAppointmentQuestionDialogComponent implements OnInit {
  loading: boolean;
  questions: LaboratoryAppointmentQuestion[] = [];

  groupedQuestions: {
    practice: string;
    questions: LaboratoryAppointmentQuestion[];
  }[] = [];

  constructor(
    private laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<LaboratoryAppointmentQuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LaboratoryAppointmentQuestion[],
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      await this.laboratoryAppointmentQuestionService.update(this.questions);
      this.dialogRef.close(true);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión",
      );
    }
  }

  ngOnInit(): void {
    this.questions = this.data ? this.data : [];
    this.groupQuestions();
  }

  private groupQuestions(): void {
    const map = new Map<string, LaboratoryAppointmentQuestion[]>();

    this.questions.forEach((q) => {
      q.ProcedureRegionNames.forEach((practice) => {
        if (!map.has(practice)) {
          map.set(practice, []);
        }
        map.get(practice)!.push(q);
      });
    });

    this.groupedQuestions = Array.from(map.entries()).map(
      ([practice, questions]) => ({
        practice,
        questions,
      }),
    );
  }
}
